import React from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  Box,
  VStack,
  Heading,
  Text,
  Icon,
} from '@chakra-ui/react';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

function PaymentUpdateStatus() {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status');
  const isSuccess = status === 'success';

  return (
    <Box minH="100vh" bg="gray.50" display="flex" alignItems="center" justifyContent="center" p={4}>
      <Box bg="white" p={10} rounded="xl" shadow="lg" maxW="500px" w="full" textAlign="center">
        <VStack spacing={5}>
          <Icon
            as={isSuccess ? FaCheckCircle : FaTimesCircle}
            boxSize={16}
            color={isSuccess ? 'green.400' : 'gray.400'}
          />
          <Heading size="lg" color={isSuccess ? 'green.700' : 'gray.700'}>
            {isSuccess ? 'Payment Method Updated' : 'Update Cancelled'}
          </Heading>
          <Text color="gray.600" fontSize="md" lineHeight="1.7">
            {isSuccess
              ? 'Your payment method has been updated successfully. Your account will now use this card for future charges. You can close this page.'
              : 'The payment method update was cancelled. If you need to update your payment method, please contact your administrator or try again using the link in your email.'}
          </Text>
          <Box pt={4} borderTopWidth="1px" borderColor="gray.200" w="full">
            <Text fontSize="sm" color="gray.500">
              AtHomeBloodDraw.com | +1 844-718-7800 | contact@athomeblooddraw.com
            </Text>
          </Box>
        </VStack>
      </Box>
    </Box>
  );
}

export default PaymentUpdateStatus;
